<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12ZM1.54839 12C1.54839 17.7629 6.2371 22.4516 12 22.4516C17.7629 22.4516 22.4516 17.7629 22.4516 12C22.4516 6.2371 17.7629 1.54839 12 1.54839C6.2371 1.54839 1.54839 6.2371 1.54839 12ZM17.6129 7.04516C15.5855 5.28871 13.2823 6.63871 12.5371 7.41774L12 7.97903L11.4629 7.41774C10.1758 6.06774 7.95484 5.68065 6.3871 7.04516C4.67903 8.52581 4.5871 11.1871 6.11613 12.7887L11.3855 18.3097C11.7242 18.6677 12.2758 18.6677 12.6194 18.3097L17.8887 12.7887C19.4129 11.1823 19.3258 8.52581 17.6129 7.04516ZM12 16.7371L16.7903 11.7145C17.5984 10.8629 17.7774 9.21774 16.6258 8.22581C15.4452 7.20484 14.0516 8.05645 13.6306 8.50161L12 10.2097L10.3694 8.50161C9.79355 7.89677 8.44839 7.29194 7.37419 8.22581C6.22258 9.21774 6.40161 10.8677 7.20968 11.7145L12 16.7371Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "HeartCircleIcon",
    setup() {
        return {};
    },
});
</script>
